import { render } from "./VitrineFooter.vue?vue&type=template&id=f6a57c3c&scoped=true"
import script from "./VitrineFooter.vue?vue&type=script&lang=js"
export * from "./VitrineFooter.vue?vue&type=script&lang=js"

import "./VitrineFooter.vue?vue&type=style&index=0&id=f6a57c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a57c3c"]])

export default __exports__